import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var font = variables.font,
  global = variables.global;
export var notFound = /*#__PURE__*/css("padding:20px;font-weight:", font.h4FontWeight, ";text-align:center;");
export var container = /*#__PURE__*/css(".allhomes-breadcrumbs{padding:10px 0 0 16px;", media('>=tablet'), "{padding-bottom:15px;max-width:", global.desktopMinWidth, ";margin:0 auto;}", media('>=desktop'), "{padding:21px 0 18px 3px;}}");